/**
 * @generated SignedSource<<6c4638e38e1d56970af022bce2a6a8dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef";
};
export type multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef$key = {
  readonly " $data"?: multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraMultipleSelectUserPickerField"
};

(node as any).hash = "cce81be96601eacce28b3398c7aff2e6";

export default node;
